'use strict';
var _ = require('lodash');
var $ = require('jquery');
var Backbone = require('backbone');

var viewError = require('./../views/error');
var viewVoteGrid = require('./../views/votegrid');
var ViewConfirm = require('./../views/voteconfirmation');
var viewLoading = require('./../views/loading');
var viewModal = require('./../views/modal');
var ViewThanks = require('./../views/thanks');
var ViewCountdown = require('./../views/countdown');
var ViewDocument = require('../views/document');
var ModelCms = require('../models/cms');

var HEADER_FOCUS_DELAY = require('./../constants/accessibility');
var PubSub = require('tscom-pubsub');
var windowlessrouter = require('tscom-util').windowlessrouter;

module.exports = function routerConstructor (options) {

    var hashState = options.hashState;
    var Router = (!hashState)? windowlessrouter : Backbone.Router;

    return Router.extend({
        controller: null,
        currentView: null,
        currentModal: null,
        routes: {
            ''              : 'home',
            'home'          : 'home',
            'faq'           : 'faq',
            'SMSterms'      : 'smsTerms',
            'confirm'       : 'confirm',
            'thanks'        : 'thanks',
            'error/:name'   : 'error',
            'loading/:name' : 'loading',
        },
        history: [],
        /**
         *
         */
        initialize: function (options) {
            if (_.isUndefined(options)) {
                return;
            }

            this.endpoints = options.endpoints;
            this.cms = options.cms;
            this.copyCms = options.copyCms;
            this.oneId = options.oneId;
            this.controller = options.controller;
            this.instanceID = $(options.el || document.body).attr('id');
            this.initialPageLoad = true;

            this.listenTo(this,'route', this._saveHistory.bind(this));

            this.$body = $(options.el || document.body);
            this.$modalScope = $(options.modal || this.$body);
            this.$app = $('<main />');

            this.$skipToMain = $('<button/>', { id: 'skip-to-main', html: 'Skip to main', class: 'skip-link', click: () => {
                this.skipLink('.header-container button.twitter'); }
            });
            this.$skipToContestants = $('<button/>', { id: 'skip-to-contestants', html: 'Skip to contestants', class: 'skip-link', click: () => {
                this.skipLink('#contestants button:not([disabled]'); }
            });

            this.$skipToSave = $('<button/>', { id: 'skip-to-save', html: 'Skip to save votes', class: 'skip-link', click: () => {
                this.skipLink('#save-votes'); }
            });

            this.$headerView = $('<div />');

            this.$abcHeaderView = $('<Header />');
            this.$abcFooterView = $('<div class="footer" />');

            this.$headerView.addClass('header-container');
            this.$headerView[0].id = 'main';
            this.$modal = $('<div class="modal"'+((_.isEqual(options.container, options.modal)? '' : ' id="'+options.uid+'Modal"' )) + '></div>');

            // adding views to the page
            this.$body.html(this.$app);
            this.$body.prepend(this.$headerView);
            this.$body.prepend(this.$abcHeaderView);
            this.$body.append(this.$abcFooterView);
            
            this.$body.prepend(this.$skipToContestants);
            this.$body.prepend(this.$skipToSave);
            this.$body.prepend(this.$skipToMain);

            this.$modalScope.append(this.$modal);
            this.$modalScope.append(this.$shareHeader);

            this.$app.addClass((top === self ? 'frame-false' : 'frame-true'));

            this.controller.createAbcHeader(this.$abcHeaderView);
            this.controller.createAbcFooter(this.$abcFooterView);

            this.controller.createHeader(this.$headerView);

            // DV-124: modal not appearing on HTC ONE M8 >:(
            this.isAndroid4x = /android 4/i.test( window.navigator.userAgent );

            this.listenTo(PubSub, 'closeModal', this.closeCurrentModal);

            this.listenTo(PubSub,'navigate',function(route){
                this.navigate(route,{ trigger: true });
            }.bind(this));
        },

        skipLink: function(selector) {
            const el = document.querySelector(selector);
            el.focus();
        },

        /**
         *
         */
        setCurrentView: function (view, route) {
            this.closeCurrentModal();
            // remove old view
            if (this.currentView !== null) {
                this.stopListening(this.currentView);
                this.currentView.remove();
                this.currentView = null;
                this.currentViewName = '';
            }

            this.$app.html(view.render().$el);

            var bodyContext = 'body-' + view.className;
            this.$app.alterClass('body-*', bodyContext);


            // store current view
            this.currentView = view;
            this.currentViewName = route;

            if(typeof view.renderedToDOM === 'function')
                view.renderedToDOM();


            this.a11yFocusHeader(HEADER_FOCUS_DELAY);

            this.controller._handlePageView(route);
            //scroll to the top
            this._scrollToTop();
            //window.scrollTo(0, 0);
        },
        /**
         *
         */
        setCurrentModal: function (view, route) {
            var modalContext = 'modal-has-' + view.className;
            var modal = new viewModal({
                model: {view: view},
                finalFocusRef: document.activeElement
            });
            this.$modalScope.alterClass('modal-has-*', modalContext);
            this.$modal.html(modal.render().$el);

            // remove old modal
            if (this.currentModal !== null) {
                if (_.isObject(this.currentModal.model.view)) {
                    this.currentModal.model.view.remove();
                }
                this.stopListening(this.currentModal);
                this.currentModal.remove();
                this.currentModal = this.controller.Views.Modal = null;
            }
            // store current modal
            this.currentModal = this.controller.Views.Modal = modal;

            if(typeof view.renderedToDOM === 'function')
                view.renderedToDOM();

            this.currentModal.trapFocus();

            this.controller._handlePageView(route);

            //scroll to the top
            this._scrollToTop();


            // DV-124: fix for modal rendering issue
            if( this.isAndroid4x ){
                var $page = $( '.page-wrapper' );
                $page.css( 'display', 'none' );

                setTimeout( function(){
                    $page.css( 'display', '' );
                }, 50 );
            }
        },
        /**
         *
         */
        closedCurrentModal: function () {
            console.log('MODAL HIDDEN');
            if (this.currentModal !== null) {
                if (_.isObject(this.currentModal.model.view)) {
                    this.currentModal.model.view.remove();
                }
                this.currentModal.remove();
                
                if (this.currentModal.finalFocusRef) {
                    this.currentModal.finalFocusRef.focus();
                }

                this.currentModal = this.controller.Views.Modal = null;
                this.$modalScope.alterClass('modal-has-*', '');

                var overlay = document.getElementById( 'telescope-refresh-android' );
                overlay.style.display = 'block';

                setTimeout( function(){
                    this.style.display = '';
                }.bind( overlay ), 250 );
            }
        },
        /**
         *
         */
        closeCurrentModal: function () {
            console.log('CLOSE CURRENT MODAL');

            // this.$modal.modal('hide');
            this.closedCurrentModal();
        },
        /**
         *
         */
        a11yFocusHeader: function(delay) {

            if(this.initialPageLoad) {
                this.initialPageLoad = false;
                return;
            }

            if (delay === undefined) delay = HEADER_FOCUS_DELAY;

            setTimeout(function() {
                this.$app.find('[data-focusable]')[0].focus();
            }.bind(this), delay);
        },
        /**
         *
         */
        home: function () {
            console.log('ROUTE HOME', this.instanceID);
            if(!this.controller._isOpen('home')){
                return;
            }

            var countdownView = new ViewCountdown({
                model: this.controller.Models.Countdown,
                config: this.cms.get('text').countdown,
                copyCms: this.copyCms,
            });

            var view = new viewVoteGrid({
                cms: this.cms,
                copyCms: this.copyCms,
                optionsList: this.controller.Collections.VoteOption,
                userModel: this.controller.Models.User,
                createShareHeader: this.controller.createShareHeader.bind( this.controller ),
                countdownView: countdownView
            });
            this.setCurrentView(view, 'Vote Grid');
            // updated so that this is only run once from setup omniture
            // trigger omniture page view
            // PubSub.trigger('omniturePage', {name: "votingPage"});

            this.listenTo(view, 'submitVotes', this.confirm);
            this.listenTo(view, 'scrollTop', this._scrollToTop);
            //launchLogin
            //this.listenTo(view, 'launchLogin', this.controller.Models.User.login.bind(this.controller.Models.User));
        },
        confirm: function() {
            console.log('ROUTE CONFIRM', this.instanceID);
            if(!this.controller._isOpen('home')){
                return;
            }

            var model = _.extend({
                recaptcha: this.cms.get('text').recaptcha
            }, this.copyCms.get('text').views_vote_confirmation );

            var countdownViewTop = new ViewCountdown({
                model: this.controller.Models.Countdown,
                config: this.cms.get('text').countdown,
                copyCms: this.copyCms,
            });

            var countdownViewBottom = new ViewCountdown({
                model: this.controller.Models.Countdown,
                config: this.cms.get('text').countdown,
                copyCms: this.copyCms,
            });

            var view = new ViewConfirm({
                model: model,
                optionsList: this.controller.Collections.VoteOption,
                isMobileDevice: this.controller.isMobileDevice,
                countdownViewTop: countdownViewTop,
                countdownViewBottom: countdownViewBottom,
                cms: this.cms,
                copyCms: this.copyCms
            });

            this.setCurrentModal(view, 'Confirm Vote');
            this.listenToOnce(view, 'submitVotes', this.controller.submitVotes.bind(this.controller));
            this.listenTo(view, 'closeModal', this.closeCurrentModal);
        },
        thanks: function() {
            console.log('ROUTE CONFIRM', this.instanceID);
            if(!this.controller._isOpen('home')){
                return;
            }

            var countdownView = new ViewCountdown({
                model: this.controller.Models.Countdown,
                config: this.cms.get('text').countdown,
                copyCms: this.copyCms,
            });

            var view = new ViewThanks({
                optionsList: this.controller.Collections.VoteOption,
                userModel: this.controller.Models.User,
                copyCms: this.copyCms,
                countdownView: countdownView,
                createShareHeader: this.controller.createShareHeader.bind( this.controller )
            });
            this.setCurrentView(view, 'Thanks');
            this.listenTo(view, 'keepVoting', this.home);
        },
        /**
         *
         */
        faq: function () {
            var model = new ModelCms({
                apiUrl: this.endpoints.cms,
                updateFrequency: 300 // every 5 mins
            }, {
                ignoreQSP:  true,
                poll: false
            });

            var view = new ViewDocument({
                model: model,
                copyCms: this.copyCms,
                type: 'faq'
            });
            this.setCurrentView(view, 'faq');
        },
        /**
         *
         */
        smsTerms: function () {
            var model = new ModelCms({
                apiUrl: this.endpoints.cms,
                updateFrequency: 300 // every 5 mins
            }, {
                ignoreQSP:  true,
                poll: false
            });

            var view = new ViewDocument({
                model: model,
                copyCms: this.copyCms,
                type: 'sms_terms'
            });

            this.setCurrentView(view, 'SMSterms');
        },
        /**
         *
         */
        error: function (name) {
            console.log('ROUTE ERROR', name, this.instanceID);
            var data = this.copyCms.get('text')['views_error'][name];
            
            if(!_.isObject(data)) {
                name = 'generic';
            }

            var view = new viewError({
                copyCms: this.copyCms,
                type: name
            });

            if(name === 'generic') {
                this.setCurrentModal(view, 'GenericError');
            } else {
                this.setCurrentView(view, name);
            }
            this.listenTo(view, 'closeModal', this.closeCurrentModal);
        },
        /**
         *
         */
        loading: function (name) {
            console.log('ROUTE LOADING', this.instanceID);
            var data = this.copyCms.get('text')['views_loading'][name];
            data = (_.isObject(data) ? data : this.copyCms.get('text')['views_loading']['generic']);

            var view = new viewLoading({
                model: data
            });
            this.setCurrentModal(view);
        },
        /**
         *
         */
        _scrollToTop: function() {
            window.scrollTo(0, 0);
            $('.page-wrapper').scrollTop(0);
            $('.page-wrapper .content').scrollTop(0);
        },
        /**
         *
         */
        _saveHistory: function(route, params){
            console.log('listener route '+this.instanceID, route, params);
            this.history.unshift({
                route: route,
                params: params
            });
        },
        /**
         *
         */
        _back: function () {
            if(!hashState){
                var previous = (this.history[0] || {});
                var route = (previous.route || '');
                var params = (previous.params || []);
                this[route].apply(this, params);
            } else {
                window.history.back();
            }
        }
    });
};



// WEBPACK FOOTER //
// ./app/scripts/routes/router.js